import POST_COMPONENT_TYPE from '../postComponentType';
import StefanZechmannHero from '../../../assets/images/stefan-zechmann-hero-section.png';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';

const stefanZechmann = {
  key: 'medical-weight-management',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.medical-weight-management.name',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: StefanZechmannHero,
      text: 'learnMoreContent.medical-weight-management.banner.text',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.medical-weight-management.aboutZechmann.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.medical-weight-management.aboutZechmann.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.aboutZechmann.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.aboutZechmann.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.medical-weight-management.expectations.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.medical-weight-management.expectations.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.expectations.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.expectations.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.medical-weight-management.goodToKnow.title',
      backgroundColor: BackgroundColor.GREEN,
      description: {
        text: 'learnMoreContent.medical-weight-management.goodToKnow.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.medical-weight-management.howToPrepare.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.medical-weight-management.howToPrepare.listItem1',
              type: 'textWithLink',
              linkText:
                'learnMoreContent.medical-weight-management.howToPrepare.linkText',
              link: 'learnMoreContent.medical-weight-management.howToPrepare.url',
            },
            {
              text: 'learnMoreContent.medical-weight-management.howToPrepare.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.howToPrepare.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.medical-weight-management.howToPrepare.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.medical-weight-management.secure.title',
      backgroundColor: BackgroundColor.GREEN,
      description: {
        text: 'learnMoreContent.medical-weight-management.secure.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title:
        'learnMoreContent.medical-weight-management.bookConsultation.title',
      backgroundColor: BackgroundColor.WHITE,
      description: {
        text: 'learnMoreContent.medical-weight-management.bookConsultation.description',
        type: 'textWithLink',
        linkText:
          'learnMoreContent.medical-weight-management.bookConsultation.linkText',
        link: 'learnMoreContent.medical-weight-management.bookConsultation.url',
      },
    },
  ],
};

export default stefanZechmann;
